

import { useParams } from "react-router-dom";
import { CargandoMedio, FormCreateUpdateCategoria } from "../../components";
import { DisenioPaginas } from "../../layout";
import { useCategoriaXID } from "../../../hooks";







export const CrearCategoria = () => {


    const { id } = useParams();
    const { categoriaXIDQuery } = useCategoriaXID(id);


    const initialState = (categoriaXIDQuery?.data)
    ? { nombre: categoriaXIDQuery?.data.nombre }
    : { nombre: '' }


    
    return (

        <DisenioPaginas titulo={`${(id != 'new') ? 'Actualizar' : 'Crear'} Categoria`} url={1} add={false} subtitulo="Información de categoria de productos">
            {(categoriaXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Categoria..." />
            :   <FormCreateUpdateCategoria initialState={initialState} />
            }
        </DisenioPaginas>

    )
    
}
